import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const ThreatMap = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 bg-gradient-to-b from-black via-cyan-950/20 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
            {t.threatMap.title}
          </h2>
          <p className="text-xl text-gray-400">{t.threatMap.subtitle}</p>
        </div>

        {/* Kaspersky Cybermap - Full Width */}
        <div className="relative group">
          <div className="absolute -inset-1 bg-gradient-to-r from-cyan-600 to-blue-600 rounded-lg blur opacity-25 group-hover:opacity-40 transition duration-300" />
          <div className="relative bg-black border border-cyan-500/30 rounded-lg overflow-hidden" style={{ height: '700px' }}>
            <iframe
              src="https://threatmap.checkpoint.com"
              width="100%"
              height="100%"
              frameBorder="0"
              title="Kaspersky Cybermap Live"
              className="rounded-lg"
              allow="fullscreen"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThreatMap;
